import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";

const OrderConfirmation = () => {
  const [selectedPlan, setSelectedPlan] = useState<string>("");

  const handleSelectPlan = (plan: string) => {
    setSelectedPlan(plan);
  };

  return (
    <Container fluid className="pricing-area pt-110 pb-90">
      <Container>
        <Row>
          <Col>
            <div
              className="section-title text-center"
              style={{ marginBottom: "50px" }}
            >
              <h2 className="title">Choose Plan</h2>
            </div>
          </Col>
        </Row>
        <div id="prices" className="pricing-plan-wrap">
          <Row>
            <Col>
              <div
                className="pricing-item"
                style={{
                  marginBottom: "30px",
                  border:
                    selectedPlan === "10GB"
                      ? "2px solid red"
                      : "1px solid #ccc",
                  cursor: "pointer",
                }}
                onClick={() => handleSelectPlan("10GB")}
              >
                <Row className="pricing-thumb">
                  <Col className="flex-column justify-content-center align-items-center text-left">
                    <h3 className="title">10 GB</h3>
                    <h5 className="sub-title">Internet</h5>
                  </Col>
                </Row>
                <div className="pricing-content">
                  <ul className="pricing-list">
                    <li>Unlimited Calls</li>
                    <li>100 SMS</li>
                  </ul>
                  <div className="price-wrap">
                    <span> Start From </span>
                    <h3 className="price">
                      $25<sub>/Month</sub>
                    </h3>
                  </div>
                </div>
              </div>
            </Col>
            <Col className="col-lg-4 col-md-6 col-sm-9">
              <div
                className="pricing-item mb-30"
                style={{
                  border:
                    selectedPlan === "20GB"
                      ? "2px solid red"
                      : "1px solid #ccc",
                  cursor: "pointer",
                }}
                onClick={() => handleSelectPlan("20GB")}
              >
                <Row className="pricing-thumb">
                  <Col className="flex-column justify-content-center align-items-center text-left">
                    <h3 className="title">20 GB</h3>
                    <h5 className="sub-title">Internet</h5>
                  </Col>
                </Row>
                <div className="pricing-content">
                  <ul className="pricing-list">
                    <li>Unlimited Calls</li>
                    <li>1000 SMS</li>
                  </ul>
                  <div className="price-wrap">
                    <span> Start From </span>
                    <h3 className="price">
                      $35<sub>/Month</sub>
                    </h3>
                  </div>
                </div>
              </div>
            </Col>
            <Col className="col-lg-4 col-md-6 col-sm-9">
              <div
                className="pricing-item mb-30"
                style={{
                  border:
                    selectedPlan === "50GB"
                      ? "2px solid red"
                      : "1px solid #ccc",
                  cursor: "pointer",
                }}
                onClick={() => handleSelectPlan("50GB")}
              >
                <Row className="pricing-thumb">
                  <Col className="flex-column justify-content-center align-items-center text-left">
                    <h3 className="title">50 GB</h3>
                    <h5 className="sub-title">Internet</h5>
                  </Col>
                </Row>
                <div className="pricing-content">
                  <ul className="pricing-list">
                    <li>2 GB Roaming</li>
                    <li>Calls</li>
                  </ul>
                  <div className="price-wrap">
                    <span> Start From </span>
                    <h3 className="price">
                      $55<sub>/Month</sub>
                    </h3>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </Container>
  );
};

export default OrderConfirmation;
